interface SpecialOfferBannerProps {
  onCTAClick: () => void;
}

const features = [
  'ホームページ又はランディングページ制作を完全無料でご提供',
  'セキュリティ対策と集客を同時に強化',
  '専任担当者による導入〜運用まで一貫サポート',
];

const SpecialOfferBanner: React.FC<SpecialOfferBannerProps> = ({ onCTAClick }) => {
  return (
    <section className="w-full bg-gradient-to-r from-slate-50 via-sky-50 to-slate-50 border-y border-sky-100">
      <div className="max-w-5xl mx-auto px-6 py-16 md:py-20">

        {/* Period badge */}
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center gap-2 bg-sky-600 text-white text-xs font-bold tracking-widest uppercase px-5 py-1.5 rounded-full">
            <i className="ri-time-line text-sky-200 text-sm" />
            期間限定
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-center text-slate-800 text-2xl md:text-3xl font-bold leading-snug mb-4 tracking-tight">
          UTM導入企業様<span className="text-sky-600">限定</span>特典
        </h2>

        {/* Divider */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="block w-16 h-px bg-sky-200" />
          <i className="ri-shield-check-line text-sky-400 text-lg" />
          <span className="block w-16 h-px bg-sky-200" />
        </div>

        {/* Main offer */}
        <div className="text-center mb-3">
          <p className="text-slate-700 text-base font-semibold mb-1">ホームページ又はランディングページ制作費（通常10万円相当）</p>
          <p className="inline-block text-4xl md:text-5xl font-extrabold text-sky-600 tracking-tight leading-none">
            無料
          </p>
        </div>

        {/* Note */}
        <p className="text-center text-slate-400 text-xs mb-10">
          ※保守管理費（月額4,980円）のみ発生します
        </p>

        {/* Feature list */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10">
          {features.map((feat) => (
            <div
              key={feat}
              className="flex items-start gap-2.5 bg-white border border-sky-100 rounded-xl px-5 py-4 flex-1 max-w-xs mx-auto sm:mx-0"
            >
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-checkbox-circle-fill text-sky-500 text-lg" />
              </span>
              <span className="text-slate-700 text-sm font-medium leading-snug">{feat}</span>
            </div>
          ))}
        </div>

        {/* Description */}
        <p className="text-center text-slate-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-4">
          UTM導入にあわせて、企業のIT環境をトータルで整備するため、<br className="hidden md:block" />
          ホームページ又はランディングページ制作を<strong className="text-sky-600">無料</strong>でご提供しております。<br className="hidden md:block" />
          セキュリティ対策と同時に「集客・信用力の強化」まで一括でサポートいたします。
        </p>

        {/* Additional note */}
        <p className="text-center text-slate-500 text-xs md:text-sm leading-relaxed max-w-2xl mx-auto mb-4">
          本サービスは、初期構築を「1ページ構成」とすることで、<br className="hidden md:block" />
          スピーディかつ低コストでの導入を実現しています。<br className="hidden md:block" />
          必要に応じて、ページ追加や機能拡張にも対応可能です（別途費用）。
        </p>

        {/* Urgency line */}
        <p className="text-center text-slate-500 text-sm font-semibold mb-10">
          👉 ※毎月<span className="text-red-600 font-extrabold">5社限定</span>のため、お早めにご相談ください
        </p>

        {/* CTA */}
        <div className="flex justify-center">
          <button
            onClick={onCTAClick}
            className="whitespace-nowrap inline-flex items-center gap-2.5 bg-sky-600 hover:bg-sky-700 text-white font-bold text-base px-10 py-4 rounded-full transition-all duration-200 cursor-pointer"
          >
            <i className="ri-shield-user-line text-sky-200 text-lg" />
            特典について相談する
          </button>
        </div>

      </div>
    </section>
  );
};

export default SpecialOfferBanner;
